exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3UjPY{margin-bottom:24px}._3UjPY ._2pjSA{padding-left:6px}._8leLe{margin-top:30px;margin-bottom:10px}._1Fgsz{opacity:0.5;pointer-events:none}\n", ""]);

// Exports
exports.locals = {
	"section": "_3UjPY",
	"learn-more-button": "_2pjSA",
	"learnMoreButton": "_2pjSA",
	"settingTitle": "_8leLe",
	"disabled": "_1Fgsz"
};